import pattern from '@/utils/pattern';

export default {
  downloadData(data, title, suffix) {
    if (!data) {
      return;
    }
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const aLink = document.createElement('a');
    if ('download' in document.createElement('a')) {
      aLink.style.display = 'none';
      aLink.href = url;
      aLink.setAttribute('download', `${title}.${suffix || 'xlsx'}`);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      window.URL.revokeObjectURL(url);
    } else {
      navigator.msSaveBlob(blob, `${title}.${suffix || 'xlsx'}`);
    }
  },
  mapScript() {
    return new Promise(resolve => {
      try {
        // eslint-disable-next-line no-undef
        resolve(BMap);
      } catch (err) {
        const ak = process.env.VUE_APP_ENV === 'qa' ? 'PilmdZ8SZzmpu7Ant7zopwVRdK52U9li' : 'a3C4whoarCGjWTd9o8O6QXnlkjH6Tgsu';
        // const ak = 'PilmdZ8SZzmpu7Ant7zopwVRdK52U9li';
        const url = `https://api.map.baidu.com/api?v=3.0&ak=${ak}`;
        const callbackName = 'init';
        window[callbackName] = () => {
          // eslint-disable-next-line no-undef
          resolve(BMap);
        };
        // 创建script标签并加载百度地图API
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `${url}&callback=${callbackName}`;
        document.body.appendChild(script);
      }
    });
  },
  baiduMapScript() {
    this.mapScript().then(() => {
      const url = '/lib/BMapLib.js';
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      document.body.appendChild(script);
    });
  },
  validatePassword(password) {
    const regex = /^[A-Za-z\d.@$!%*#_~?&^]{8,20}$/;
    let count = 0;
    // 检查数字
    if (/\d/.test(password)) {
      count += 1;
    }
    // 检查小写字母
    if (/[a-z]/.test(password)) {
      count += 1;
    }
    // 检查大写字母
    if (/[A-Z]/.test(password)) {
      count += 1;
    }

    // 检查特殊符号
    if (/[.@$!%*#_~?&^]/.test(password)) {
      count += 1;
    }
    return [regex.test(password), count >= 3];
  }

};
